import { css } from '@emotion/react'
import { Flow, Icon, Table, TableBody, TableCell, TableRow, Text, VFlow } from 'bold-ui'
import { blue, gray } from 'bold-ui/lib/styles/colors'
import { useFlags } from 'config/useFlagsContext'
import { ReactComponent as SignatureIcon } from 'images/atendimento/assinador/icon-signature.svg'
import { ReactComponent as Consulta } from 'images/historico/icone-consulta.svg'
import { ReactComponent as PreNatalIcon } from 'images/historico/icone-pre-natal.svg'
import { ReactComponent as PuerperioIcon } from 'images/historico/icone-puerperio.svg'
import { ReactComponent as AcompanhamentoCondicoesDeSaudeIcon } from 'images/side-menu/acompanhamentos.svg'
import { ReactComponent as AtividadeColetivaIcon } from 'images/side-menu/atividade-coletiva.svg'
import { ReactComponent as CidadaoIcon } from 'images/side-menu/cidadao.svg'
import { ReactComponent as GarantiaAcessoIcon } from 'images/side-menu/garantia-acesso.svg'
import { ReactComponent as IntegracaoIcon } from 'images/side-menu/integracao.svg'
import { ReactComponent as Relatorios } from 'images/side-menu/relatorios.svg'
import { ReactComponent as SdcIcon } from 'images/suporte-decisao-clinica/health-system-outline.svg'
import { Fragment } from 'react'

import PuericulturaIcon from '../../../images/soap/ic_puericultura.webp'
import { Carousel, CarouselItem } from '../components/Carousel'
import { ExpandableText } from '../components/ExpandableText'
import { NewsGif } from '../components/NewsGif'
import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsImg } from '../components/NewsImg'
import { NewsListItem } from '../components/NewsListItem'

export function NewsInternalPanelCincoCinco() {
  const {
    RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED,
    PILOTO_PRONTUARIO_FAMILIAR_ENABLED,
    PILOTO_SDC_PRE_ECLAMPSIA_ENABLED,
    PILOTO_RNDS_REPM_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED,
    PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED,
    PILOTO_VINCULACAO_CUIDADO_ENABLED,
    PILOTO_INTEGRACAO_REGULACAO_ENABLED,
    PILOTO_ASSINADOR_REPM_ENABLED,
    PILOTO_ATENDIMENTO_SOCIOEDUCATIVO_ENABLED,
    PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED,
    PILOTO_EXAMES_SAUDE_MULHER_ENABLED,
    PILOTO_M_CHAT_RF_ENABLED,
    PILOTO_GRAFICOS_PRE_TERMO_ENABLED,
    PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED,
    PILOTO_INATIVACAO_IMOVEIS_ENABLED,
    PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED,
    PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED,
    MOTIVO_PRESCRICAO_ENABLED,
    SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED,
    PILOTO_CID11_ENABLED,
  } = useFlags()

  const listaCidsCardiovascular =
    'I11, I11.0, I11.9, I12, I12.0, I12.9, I13, I13.0, I13.1, I13.2, I13.9, I15.0, I15.1, I20, I20.0, I20.1, I20.8, I20.9, I21, I21.0, I21.1, I21.2, I21.3, I21.4, I21.9, I22, I22.0, I22.1, I22.8, I22.9, I23, I23.0, I23.1, I23.2, I23.3, I23.4, I23.5, I23.6, I23.8, I24, I24.0, I24.8, I24.9, I25, I25.0, I25.1, I25.2, I25.3, I25.4, I25.5, I25.6, I25.8, I25.9, I42.9, I50, I50.0, I50.1, I50.9, I51.6, I60, I60.0, I60.1, I60.2, I60.3, I60.4, I60.5, I60.6, I60.7, I60.8, I60.9, I61, I61.0, I61.1, I61.2, I61.3, I61.4, I61.5, I61.6, I61.8, I61.9, I63, I63.0, I63.1, I63.2, I63.3, I63.4, I63.5, I63.8, I63.9, I64, I65, I65.0, I65.1, I65.2, I65.3, I65.8, I65.9, I66, I66.0, I66.1, I66.2, I66.3, I66.4, I66.8, I66.9, I67, I67.0, I67.1, I67.2, I67.3, I67.4, I67.7, I67.8, I67.9, I69, I69.0, I69.1, I69.2, I69.3, I69.4, I70, I70.0, I70.1, I70.2, I70.8, I70.9, I71, I71.0, I71.1, I71.2, I71.3, I71.4, I71.5, I71.6, I71.8, I71.9, I72, I72.0, I72.1, I72.2, I72.3, I72.4, I72.8, I72.9, I74, I74.0, I74.1, I74.2, I74.3, I74.4, I74.5, I74.8, I74.9, I79.0 ou O11'

  const listaCidsDiabetesMellitus =
    'E10, E10.0, E10.1, E10.2, E10.3, E10.4, E10.5, E10.6, E10.7, E10.8, E10.9, E11, E11.0, E11.1, E11.2, E11.3, E11.4, E11.5, E11.6, E11.7, E11.8, E11.9, E12, E12.0, E12.1, E12.2, E12.3, E12.4, E12.5, E12.6, E12.7, E12.8, E12.9, E13, E13.0, E13.1, E13.2, E13.3, E13.4, E13.5, E13.6, E13.7, E13.8, E13.9, E14, E14.0, E14.1, E14.2, E14.3, E14.4, E14.5, E14.6, E14.7, E14.8, E14.9, O24.0, O24.1, O24.2 ou O24.3'

  return (
    <Fragment>
      {PILOTO_CID11_ENABLED && (
        <NewsHeadingSection
          title='Inclusão do campo de CID-11 na Avaliação do SOAP e na Lista de problemas/condições'
          icon={<Consulta css={styles.iconSVG} />}
          id='cid11-problemas-condicoes-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O PEC foi atualizado com a inclusão do campo de CID-11, a 11ª revisão da Classificação Internacional de
              Doenças, trazendo novos códigos para registro e classificação de condições de saúde.
            </Text>
            <Text fontSize={0.875} component='p'>
              Agora, a Avaliação e a Lista de problemas/condições do SOAP contam com um campo de CID-11 complementar à
              CID-10. Ao informar um código no campo de CID-10, o campo de CID-11 exibe códigos correspondentes ao
              código informado. Além disso, a CID-11 registrada também pode ser incluída na Lista de
              problemas/condições.
            </Text>
            <Text fontSize={0.875} component='p'>
              Neste momento, a CID-11 não substitui a CID-10: seu preenchimento é complementar, opcional e tem caráter
              informativo, apoiando a transição gradual para o novo padrão de classificação.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_cid11_problemas_condicoes_A.webp'
                alt='Imagem exibindo o campo de CID-11 na Lista de problemas/condições'
              />
              <CarouselItem
                image='/static/novidades/5-5_cid11_problemas_condicoes_B.webp'
                alt='Imagem exibindo o campo de CID-11 na Lista de problemas/condições com opções de CID-11'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Novos itens nos campos do registro de Atividade coletiva'
        icon={<AtividadeColetivaIcon css={styles.iconSVG} />}
        id='novos-temas-public-alvo-ac-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875} component='p'>
            Agora no registro de Atividade Coletiva é possível informar o tema <strong>Vigilância em saúde</strong> para
            atividades em reunião e os públicos-alvo{' '}
            <strong>Adolescente em atendimento socioeducativo em meio aberto</strong> e{' '}
            <strong>Adolescente em atendimento socioeducativo em meio fechado</strong> em atividades em saúde.
          </Text>
          <Text fontSize={0.875} component='p'>
            Os novos itens também estão disponíveis no relatório de produção de Atividade Coletiva e em seus filtros
            personalizados.
          </Text>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-5_ac_novo_tema_reuniao.png'
              alt='Imagem exibindo novo tema para reunião em Vigilância em saúde na AC'
            />
            <CarouselItem
              image='/static/novidades/5-5_ac_novos_publicos-alvo.png'
              alt='Imagem exibindo novo público-alvo de Adolescentes em meio aberto/fechado na AC'
            />
          </Carousel>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Atualização SIGTAP' id='sigtap-5-5'>
        <VFlow vSpacing={0.5}>
          <NewsListItem>
            Atualização da tabela de procedimentos SIGTAP para a competência de 05/2026, trazendo inclusões e alterações
            de procedimentos.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Novo modelo de atestado para Solicitação de fraldas geriátricas'
        icon={<Consulta css={styles.iconSVG} />}
        id='solicitacao-fraldas-geriatricas-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875} component='p'>
            O módulo de Atestados passa a contar com um novo modelo destinado à{' '}
            <strong>Solicitação de fraldas geriátricas</strong>, desenvolvido com o objetivo de padronizar e simplificar
            o preenchimento das informações relacionadas à concessão do insumo.
          </Text>
          <Text fontSize={0.875} component='p'>
            O novo modelo contempla os seguintes campos:
          </Text>
          <Text component='ul' style={styles.noMarginUl}>
            <NewsListItem fontSize={0.875}>Data;</NewsListItem>
            <NewsListItem fontSize={0.875}>Tamanho da fralda (P, M, G, GG e XG);</NewsListItem>
            <NewsListItem fontSize={0.875}>Recomendação diária;</NewsListItem>
            <NewsListItem fontSize={0.875}>
              Total de unidades, correspondente à quantidade mensal de fraldas, calculada automaticamente com base na
              recomendação diária informada;
            </NewsListItem>
            <NewsListItem fontSize={0.875}>CID-10, com preenchimento opcional.</NewsListItem>
          </Text>
          <Text fontSize={0.875} component='p'>
            A iniciativa busca proporcionar maior clareza e agilidade no preenchimento do atestado, além de promover
            maior consistência das informações registradas e apoiar a emissão do documento pelas equipes de saúde.
          </Text>
          <Carousel>
            <CarouselItem
              image='/static/novidades/5-5_solicitacao_fraldas_geriatricas_A.webp'
              alt='Imagem exibindo solicitação de fraldas geriátricas'
            />
            <CarouselItem
              image='/static/novidades/5-5_solicitacao_fraldas_geriatricas_B.webp'
              alt='Imagem exibindo solicitação de fraldas geriátricas com CID-10'
            />
          </Carousel>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Inativação de procedimentos AB no sistema' id='inativacao-procedimentos-ab-5-5'>
        <VFlow vSpacing={0.5}>
          <NewsListItem fontSize={0.875}>
            Os procedimentos classificados como do tipo <strong>AB</strong> que possuíam equivalência na tabela{' '}
            <strong>SIGTAP</strong> foram inativados no sistema, permanecendo disponíveis para seleção apenas aqueles
            vinculados à tabela <strong>SIGTAP</strong>.
          </NewsListItem>
          <NewsListItem fontSize={0.875}>
            A alteração contempla tanto o CDS quanto os módulos do PEC e foi realizada com o objetivo de promover a
            padronização das terminologias utilizadas no sistema, garantindo maior consistência e alinhamento com os
            padrões de SIGTAP.
          </NewsListItem>
          <NewsListItem fontSize={0.875}>
            Além disso, a iniciativa busca reduzir inconsistências operacionais e evitar conflitos gerados por
            duplicidades de procedimentos existentes entre as tabelas, contribuindo para uma melhor integridade dos
            registros, maior rastreabilidade das informações e simplificação do processo de seleção e manutenção dos
            procedimentos na aplicação.
          </NewsListItem>
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_RNDS_REPM_ENABLED && (
        <NewsHeadingSection
          title='RNDS - Registro Eletrônico de Prescrição de Medicamentos (REPM)'
          icon={<Icon icon='medicineBottleFilled' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='rnds-repm-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875}>
              O e-SUS APS passa a enviar os registros de prescrição para a RNDS nos formatos Registro de Prescrição de
              Medicamento (RPM) ou Registro Eletrônico de Prescrição de Medicamento (REPM).
            </Text>
            <Text fontSize={0.875}>A escolha do formato é determinada pela classificação do medicamento:</Text>
            <Text component='ul'>
              <NewsListItem fontSize={0.875}>
                REPM: Utilizado para medicamentos cujo código CATMAT possui código correspondente na OBM;
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                RPM: Utilizado para medicamentos cujo código CATMAT não possui correspondência de código na OBM.
              </NewsListItem>
            </Text>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection title='Evolução do Módulo do Cidadão' id='novo-cidadao-5-5' icon={<CidadaoIcon />}>
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875}>
            O Módulo do Cidadão evoluiu e agora se chama Cadastro individual! Ele passa a centralizar a gestão dos
            cadastros, gerando fichas automáticas conforme necessário. As principais mudanças nesse módulo incluem:
          </Text>
          <Text component='ul'>
            <NewsListItem fontSize={0.875}>
              Não há mais necessidade de utilizar a antiga Ficha de Cadastro Individual, pois as informações que antes
              eram registradas nela agora foram integradas ao módulo do Cadastro individual.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Integração com o Acompanhamento do território: mudanças no módulo do Cadastro individual refletem na
              composição familiar e vinculação do território.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              O campo CPF passa a ser obrigatório na seção de Dados Pessoais, diminuindo a possibilidade de cadastros
              duplicados.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Os campos relacionados a Informações sociodemográficas, Informações socioeconômicas e Condições de saúde
              autorreferidas foram integrados ao módulo, permitindo maior detalhamento de informações no cadastro. Eles
              podem ser preenchidos ao abrir as suas respectivas seções expansíveis, sendo exibidos em cadastros na
              Atenção Primária à Saúde.
            </NewsListItem>
            {PILOTO_ATENDIMENTO_SOCIOEDUCATIVO_ENABLED && (
              <NewsListItem fontSize={0.875}>
                O Cadastro individual passa a permitir o registro de informações relacionadas ao atendimento
                socioeducativo de adolescentes entre 12 e 21 anos, incluindo o tipo e o tempo de atendimento
                socioeducativo nas Informações sociodemográficas.
              </NewsListItem>
            )}
            <NewsListItem fontSize={0.875}>
              Em cadastros e atualizações realizados na APS é possível definir, a partir de uma lotação ativa, a Equipe
              de referência vinculada ao cidadão, substituindo o antigo preenchimento de informações do profissional que
              era feito no cabeçalho da Ficha de Cadastro Individual.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Ao digitar as informações de identificação do cidadão em um novo cadastro, o sistema automaticamente
              identifica a possibilidade de duplicação de cadastro e, se for o caso, sugere mudar para uma atualização.
            </NewsListItem>
          </Text>
          <NewsGif
            src='/static/novidades/5-5_cadastro_individual.webm'
            pausedSrc='/static/novidades/5-5_cadastro_individual_paused.webp'
            alt='Gif mostrando o novo módulo do Cadastro individual'
          />
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_SDC_RISCO_CARDIOVASCULAR_SEGUNDA_ENTREGA_ENABLED && (
        <NewsHeadingSection
          title='Aprimoramento do cálculo no SDC de Risco Cardiovascular'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-cardiovascular-segunda-entrega-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O Suporte à Decisão Clínica (SDC) agora conta com um cálculo de Risco Cardiovascular (RCV) ampliado,
              estruturado com base na metodologia da calculadora HEARTS adaptada. Essa atualização contempla mais
              cenários clínicos, permitindo uma determinação de risco mais assertiva, de acordo com os registros do
              prontuário do cidadão e as diretrizes estabelecidas.
            </Text>
            <Text fontSize={0.875} component='p'>
              Além de considerar registros de Doenças Cardiovasculares, Doença Renal Crônica e Diabetes Mellitus em
              cidadãos com idade entre 40 anos e 75 anos, o sistema agora também realiza o cálculo para aqueles que não
              possuem essas condições inseridas no prontuário.
            </Text>
            <Text fontSize={0.875} component='p'>
              Para o cálculo ampliado de Risco Cardiovascular, o sistema considera os seguintes fatores:
            </Text>
            <Text component='ul'>
              <NewsListItem fontSize={0.875}>Sexo</NewsListItem>
              <NewsListItem fontSize={0.875}>Idade</NewsListItem>
              <NewsListItem fontSize={0.875}>
                Tabagismo (condição registrada na Lista de Problemas e Condições)
              </NewsListItem>
              <NewsListItem fontSize={0.875}>Pressão arterial sistólica (registrada nas últimas 24h)</NewsListItem>
              <NewsListItem fontSize={0.875}>Colesterol total (registrado nos últimos 365 dias)</NewsListItem>
              <NewsListItem fontSize={0.875}>
                IMC (registrado nas últimas 24h), no caso de ausência de registro de colesterol total
              </NewsListItem>
            </Text>
            <Text fontSize={0.875} component='p'>
              Essa melhoria amplia a cobertura do cálculo, apoiando a estratificação de risco e fortalecendo a tomada de
              decisão clínica no cuidado longitudinal do cidadão.
            </Text>
            <Text fontSize={0.875} component='p'>
              Além disso, o card de Rastreamentos foi adaptado para também contemplar os cenários de baixo risco e
              moderado risco cardiovascular. Nesses casos, o sistema passa a apresentar alertas específicos acompanhados
              de condutas recomendadas, apoiando o profissional de saúde na orientação e no acompanhamento adequado do
              cidadão conforme o nível de risco identificado.
            </Text>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Batimento cardíaco fetal para gestação dupla/gemelar'
        icon={<Icon icon='heartRateFilled' />}
        id='batimento-cardiaco-fetal2-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text component='ul' style={styles.noMarginUl}>
            <NewsListItem fontSize={0.875}>
              Inclusão de campo para informar o{' '}
              <strong>batimento cardíaco fetal para contemplar cenários de gestação dupla/gemelar</strong>.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              A nova informação é contemplada nos locais de exibição onde o batimento cardíaco fetal já é apresentado,
              como as medições da gestação, histórico e acompanhamento do pré-natal.
            </NewsListItem>
          </Text>
          <NewsGif
            src='/static/novidades/5-5_batimento_cardiaco_fetal2.webm'
            pausedSrc='/static/novidades/5-5_batimento_cardiaco_fetal2_paused.webp'
            alt='Gif mostrando o atendimento de pré-natal com os dois campos de batimento cardíaco fetal'
          />
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_VULNERABILIDADE_FAMILIAR_ENABLED && (
        <NewsHeadingSection title='Classificação de Vulnerabilidade Familiar' id='vulnerabilidade-familiar-5-5'>
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875}>
              O PEC agora oferece uma classificação automática de vulnerabilidade familiar. Essa classificação analisa
              informações provenientes do cadastro individual, do núcleo familiar, do imóvel, do registro de problemas e
              condições de saúde, com o objetivo de identificar famílias que demandam maior atenção pelas equipes. Os
              três níveis de classificação são:
            </Text>
            <Text component='ul'>
              <NewsListItem fontSize={0.875}>
                <strong>Vulnerabilidade Inequívoca:</strong> Quando presente alguma condição específica que já indica
                vulnerabilidade imediata, a família é classificada neste nível, com listagem de todos os indicadores
                encontrados.
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>Vulnerabilidade Sugestiva:</strong> Quando há condições sugestivas de vulnerabilidade, o sistema
                calcula um escore que define o grau de risco (habitual, baixa, média ou máxima).
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>Vulnerabilidade Habitual:</strong> Quando não há indicadores de vulnerabilidade presentes na
                família.
              </NewsListItem>
            </Text>
            <Text fontSize={0.875}>
              A classificação é exibida na Folha de Rosto, no Prontuário Familiar e na visualização do Imóvel, e em cada
              local é possível acessar a listagem completa dos indicadores encontrados, assim como uma explicação mais
              detalhada da metodologia.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_folha_de_rosto.webp'
                alt='Vulnerabilidade Familiar - Folha de Rosto'
              />
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_prontuario_familiar.webp'
                alt='Vulnerabilidade Familiar - Prontuário Familiar'
              />
              <CarouselItem
                image='/static/novidades/5-5_vulnerabilidade_familiar_visualizar_imovel.webp'
                alt='Vulnerabilidade Familiar - Visualizar Imóvel'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Módulo de Acompanhamento de Pré-natal'
        icon={<PreNatalIcon />}
        id='acompanhamento-pre-natal-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875}>
            Agora é possível visualizar, de forma integrada, todas as informações relacionadas ao pré-natal da gestação
            em curso. A funcionalidade organiza e centraliza os registros de consultas, exames, vacinas e outros
            procedimentos, facilitando o acompanhamento e cuidado da gestante.
          </Text>
          <Text fontSize={0.875}>Visualize de forma integrada todas as informações:</Text>
          <ul>
            <NewsListItem fontSize={0.875}>Antecedentes obstétricos;</NewsListItem>
            <NewsListItem fontSize={0.875}>Informações resumidas da gestação atual;</NewsListItem>
            <NewsListItem fontSize={0.875}>Acompanhamento de vulnerabilidades;</NewsListItem>
            <NewsListItem fontSize={0.875}>Medições da gestante;</NewsListItem>
            <NewsListItem fontSize={0.875}>Medicamentos em uso;</NewsListItem>
            <NewsListItem fontSize={0.875}>Lista de problemas e condições;</NewsListItem>
            <NewsListItem fontSize={0.875}>Problemas e condições autorreferidas;</NewsListItem>
            <NewsListItem fontSize={0.875}>Consultas de Pré-natal;</NewsListItem>
            <NewsListItem fontSize={0.875}>Atividade coletiva;</NewsListItem>
            <NewsListItem fontSize={0.875}>Vacinação;</NewsListItem>
            <NewsListItem fontSize={0.875}>Exames;</NewsListItem>
            <NewsListItem fontSize={0.875}>Encaminhamento;</NewsListItem>
            <NewsListItem fontSize={0.875}>Visitas domiciliares;</NewsListItem>
            <NewsListItem fontSize={0.875}>Próximos agendamentos.</NewsListItem>
          </ul>
          <NewsGif
            src='/static/novidades/5-5_acompanhamento_pre_natal.webm'
            pausedSrc='/static/novidades/5-5_acompanhamento_pre_natal_paused.webp'
            alt='Gif mostrando o novo módulo de Acompanhamento de Pré-natal'
          />
          <Text fontSize={0.875}>
            O módulo foi desenvolvido para destacar as informações mais relevantes durante o pré-natal, apoiando o
            profissional na tomada de decisão de forma mais ágil, segura e centrada na pessoa.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection
        title='Módulo de Acompanhamento de Puerpério'
        icon={<PuerperioIcon />}
        id='acompanhamento-puerperio-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875}>
            Agora é possível visualizar, de forma integrada, todas as informações relacionadas ao puerpério em curso. A
            funcionalidade organiza e centraliza os registros de consultas, exames, vacinas e outros procedimentos,
            facilitando o acompanhamento e cuidado da puérpera.
          </Text>
          <Text fontSize={0.875}>Visualize de forma integrada todas as informações:</Text>
          <ul>
            <NewsListItem fontSize={0.875}>Informações resumidas do puerpério atual;</NewsListItem>
            <NewsListItem fontSize={0.875}>Acompanhamento de vulnerabilidades;</NewsListItem>
            <NewsListItem fontSize={0.875}>Medições da puérpera;</NewsListItem>
            <NewsListItem fontSize={0.875}>Medicamentos em uso;</NewsListItem>
            <NewsListItem fontSize={0.875}>Lista de problemas e condições;</NewsListItem>
            <NewsListItem fontSize={0.875}>Consultas de Puerpério;</NewsListItem>
            <NewsListItem fontSize={0.875}>Visitas domiciliares;</NewsListItem>
            <NewsListItem fontSize={0.875}>Atividade coletiva;</NewsListItem>
            <NewsListItem fontSize={0.875}>Vacinação;</NewsListItem>
            <NewsListItem fontSize={0.875}>Exames;</NewsListItem>
            <NewsListItem fontSize={0.875}>Próximos agendamentos;</NewsListItem>
            <NewsListItem fontSize={0.875}>Novo card de puerpério na lateral do atendimento.</NewsListItem>
          </ul>
          <NewsGif
            src='/static/novidades/5-5_acompanhamento_puerperio.webm'
            pausedSrc='/static/novidades/5-5_acompanhamento_puerperio_paused.webp'
            alt='Gif mostrando o novo módulo de Acompanhamento de Puerpério'
          />
          <Text fontSize={0.875}>
            O módulo foi desenvolvido para destacar as informações mais relevantes durante o puerpério, apoiando o
            profissional na tomada de decisão de forma mais ágil, segura e centrada na pessoa.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      {RETIFICACAO_ATENDIMENTO_VACINACAO_ENABLED && (
        <NewsHeadingSection title='Retificação de atendimento de vacinação' id='retificacao-atendimento-vacinacao-5-5'>
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='li'>
              Foi adicionada a funcionalidade de retificar atendimentos de vacinação. Agora, o profissional que realizou
              o atendimento pode corrigir informações, incluir aplicações de imunobiológicos realizados naquele
              atendimento ou remover registros específicos inseridos de forma equivocada, sem a necessidade de excluir o
              atendimento como um todo.
            </Text>
            <Text fontSize={0.875} component='li'>
              O registro retificado é inativado e as alterações realizadas podem ser visualizadas na Trilha de Auditoria
              e impressas através do histórico do cidadão.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_vacinacao_1.webp'
                alt='Imagem exibindo o histórico do cidadão com a retificação de vacinação'
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_vacinacao_2.webp'
                alt='Imagem exibindo o modal de retificação de vacinação'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Sistemas externos'
        icon={<IntegracaoIcon css={styles.iconSVG} />}
        id='sistemas-externos-5-5'
      >
        <VFlow vSpacing={0.5}>
          <NewsListItem fontSize={0.875}>
            Com o objetivo de centralizar as informações e otimizar a rotina das equipes de saúde, a nova versão do
            e-SUS APS traz a funcionalidade de sistemas externos. Agora, é possível utilizar outros sistemas diretamente
            do prontuário, eliminando a necessidade de abrir abas separadas, alternar janelas ou realizar novos logins
            durante o trabalho.
          </NewsListItem>
          <NewsListItem fontSize={0.875}>
            No menu lateral e durante os atendimentos individuais e odontológicos, os profissionais de saúde têm acesso
            a uma nova aba chamada Sistemas externos.
          </NewsListItem>
          <NewsListItem fontSize={0.875}>
            A aba Sistemas externos só fica visível no atendimento se houver algum sistema previamente configurado pelo
            administrador da instalação.
          </NewsListItem>
          <NewsGif
            src='/static/novidades/5-5_sistemas_externos.gif'
            pausedSrc='/static/novidades/5-5_sistemas_externos.png'
            alt='Gif mostrando o sistema externo "Manual e-SUS APS" aberto pelo menu principal e pela aba Sistemas externos durante um atendimento individual.'
          />
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_SDC_RISCO_CARDIOVASCULAR_ENABLED && (
        <NewsHeadingSection
          title='Suporte à Decisão Clínica - Alerta de Risco Cardiovascular'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-cardiovascular-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O Suporte à Decisão Clínica conta com um novo fluxo para todos os cidadãos com idade entre {'>'}= 40 anos
              e {'<'} 75 anos. Nesse caso, o SDC utiliza todos os registros de CIAP-2 ou CID-10 na seção de
              problemas/condições para decidir se dispara alerta de "Risco cardiovascular Muito Alto identificado" ou
              "Risco cardiovascular Alto identificado".
            </Text>
            <Text fontSize={0.875} component='p'>
              Para o "Risco cardiovascular Muito Alto identificado" ao menos um dos CID-10 e CIAP-2 está presente com
              qualquer situação:
            </Text>
            <Table style={{ tableLayout: 'fixed', width: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Cardiovascular</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CIAP-2: </Text> K74, K75, K76, K77, K87, K89, K90, K91, K92 ou K99
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Cardiovascular</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text>
                    <ExpandableText texto={listaCidsCardiovascular}></ExpandableText>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Text fontSize={0.875} component='p'>
              Para o "Risco cardiovascular Alto identificado" ao menos um dos CID-10 e CIAP-2 está presente com qualquer
              situação:
            </Text>
            <Table style={{ tableLayout: 'fixed', width: '100%' }}>
              <TableBody>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Diabetes Mellitus</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CIAP-2: </Text> T89, T90
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Diabetes Mellitus</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text>
                    <ExpandableText texto={listaCidsDiabetesMellitus}></ExpandableText>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>Doença Renal Crônica</Text>
                  </TableCell>
                  <TableCell style={{ padding: '16px 16px' }}>
                    <Text fontWeight='bold'>CID-10: </Text> N18, N18.0, N18.8, N18.9 ou N19
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Text fontSize={0.875} component='p'>
              Caso algum risco cardiovascular seja detectado, o sistema exibe o card "Rastreamentos" na lateral do
              atendimento:
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_card_rastreamento_risco_cardiovascular_alto.webp'
                alt='Card de rastreamento para risco cardiovascular alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_card_rastreamento_risco_cardiovascular_muito_alto.webp'
                alt='Card de rastreamento para risco cardiovascular muito alto'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Quando um profissional de saúde registra alguns dos CID-10 ou CIAP-2 o sistema dispara o alerta
              correspondente: "Conduta recomendada para Risco Cardiovascular - Risco Alto" ou "Conduta recomendada para
              Risco Cardiovascular - Risco Muito Alto".
            </Text>
            <Text fontSize={0.875} component='p'>
              Textos de Conduta recomendada para Risco Cardiovascular - Risco Alto:
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_1.webp'
                alt='Primeira parte do texto de conduta recomendada para risco alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_2.webp'
                alt='Segunda parte do texto de conduta recomendada para risco alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_alto_parte_3.webp'
                alt='Terceira parte do texto de conduta recomendada para risco alto'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Textos de Conduta recomendada para Risco Cardiovascular - Risco Muito Alto:
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_1.webp'
                alt='Primeira parte do texto de conduta recomendada para risco muito alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_2.webp'
                alt='Segunda parte do texto de conduta recomendada para risco muito alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_3.webp'
                alt='Terceira parte do texto de conduta recomendada para risco muito alto'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_texto_conduta_recomendada_risco_muito_alto_parte_4.webp'
                alt='Quarta parte do texto de conduta recomendada para risco muito alto'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_SDC_PRE_ECLAMPSIA_ENABLED && (
        <NewsHeadingSection
          title='Suporte à Decisão Clínica - Alerta de Risco de Pré-Eclâmpsia'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='sdc-alerta-risco-pre-eclampsia-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O Suporte à Decisão Clínica dispara os seguintes alertas de risco de Pré-Eclâmpsia: "Gestante com risco de
              pré-eclâmpsia identificado" e "Conduta recomendada para risco de pré-eclâmpsia" sempre que há uma gravidez
              ativa no prontuário da cidadã atendida e pelo menos uma das condições abaixo é identificada.
            </Text>
            <Text component='ul' style={styles.noMarginUl}>
              <NewsListItem fontSize={0.875}>
                O usuário registra no atendimento atual ou o prontuário possui registro na Lista de Problemas ou
                Condições (LPC), com qualquer situação ("Ativa", "Latente" ou "Resolvida"), de algum dos seguintes
                problemas/condições (CID-10 ou CIAP-2): Diabetes Mellitus, Hipertensão, Gestação Múltipla, Obesidade,
                Doença Renal, Lúpus Eritematoso Sistêmico, Síndrome de Anticorpo Antifosfolípide, Doença Falciforme ou
                Fertilização In Vitro;
              </NewsListItem>
              <NewsListItem fontSize={0.875}>O tipo de gravidez é "Dupla/gemelar" ou "Tripla ou mais";</NewsListItem>
              <NewsListItem fontSize={0.875}>
                O prontuário possui registro de IMC pré-gestacional maior ou igual a 30 (sendo considerado o valor mais
                próximo da DUM, até 2 meses antes ou até 8 semanas de IG cronológica);
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                O prontuário possui registro na LPC com situação "Resolvida" de algum dos seguintes problemas/condições
                (CID-10 ou CIAP-2): Pré-eclâmpsia, Eclâmpsia ou HELLP.
              </NewsListItem>
            </Text>
            <Text fontSize={0.875} component='p'>
              <Text fontWeight='bold' component='strong'>
                IMPORTANTE:{' '}
              </Text>
              Os alertas de Risco de Pré-Eclâmpsia não são disparados caso o usuário registre no atendimento atual ou o
              prontuário possua registro na LPC com a situação "Ativa" ou "Latente" de Pré-eclâmpsia, Eclâmpsia ou
              HELLP.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_gestante_com_risco_de_pre-eclampsia_identificado.webp'
                alt='Modal do Suporte à Decisão Clínica exibindo alerta de Gestante com risco de pré-eclâmpsia identificado, com explicação sobre a análise feita pelo sistema e seções para fatores verificados ou não automaticamente.'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_conteudo_accordions_fatores_identificados_ou_nao_automaticamento_pelo_sistema.webp'
                alt='Conteúdo do modal do Suporte à Decisão Clínica exibindo alerta de Gestante com risco de pré-eclâmpsia identificado, com explicação sobre a análise feita pelo sistema e detalhamento do motivo do risco de pré-eclâmpsia identificado, apresentando dois grupos de fatores: os verificados automaticamente pelo sistema, listados em tabela com fonte das informações, e os não verificados automaticamente, mostrados em lista de itens.'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_alerta_conduta_recomendada_para_risco_de_pre_eclampsia.webp'
                alt='Modal do Suporte à Decisão Clínica exibindo alerta de Conduta recomendada para risco de pré-eclâmpsia, listando medicamentos sugeridos e orientações à gestante.'
              />
              <CarouselItem
                image='/static/novidades/5-5_sdc_conteudo_alerta_conduta_recomendada_para_risco_de_pre_eclampsia.webp'
                alt='Conteúdo do modal do Suporte à Decisão Clínica exibindo alerta de Conduta recomendada para risco de pré-eclâmpsia, listando medicamentos sugeridos e orientações à gestante, como suplementação com carbonato de cálcio, ácido acetilsalicílico, prática de atividade física, alimentação saudável e sinais de alerta para buscar atendimento. No final constam as referências da conduta recomendada.'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Além disso, o status do risco de pré-eclâmpsia é exibido no card de pré-natal (na lateral do atendimento)
              e nos campos de pré-natal. O status é exibido como "Não identificado" por padrão, mas muda para
              "Identificado" caso o sistema identifique alguma condição de risco.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_atendimento_pre_natal.webp'
                alt='Imagem com destaque para o risco de pré-eclâmpsia identificado em um atendimento, exibido no card lateral de pré-natal e também na seção do Suporte à Decisão Clínica no final do formulário Pré-natal, parto e nascimento.'
              />
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_card_pre_natal.webp'
                alt='No card de informações do Pré-natal, há um campo com o texto "Risco de pré-eclâmpsia:" seguido por um selo vermelho com a palavra "Identificado", indicando que o risco foi detectado pelo sistema.'
              />
              <CarouselItem
                image='/static/novidades/5-5_status_risco_pre_eclampsia_campo_pre_natal.webp'
                alt='No final do formulário Pré-natal, parto e nascimento, há uma seção do Suporte à Decisão Clínica. Ela informa que o sistema analisa os dados do prontuário para identificar riscos. O texto mostra que foi identificado risco de pré-eclâmpsia, com um selo em vermelho com a palavra "Identificado". Há também uma observação indicando que o risco foi atualizado pelo SDC em uma data (não preenchida na imagem)'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Evolução na vinculação de cidadãos e famílias'
        icon={<AcompanhamentoCondicoesDeSaudeIcon css={styles.iconSVG} />}
        id='vinculacao-cidadao-formacao-familias-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875} component='li'>
            Na versão 5.5 do Prontuário Eletrônico e-SUS APS, a vinculação ficou mais simples e organizada. Agora, cada
            cidadão passa a estar vinculado apenas a uma equipe, unidade e família por vez, sempre respeitando a
            atualização mais recente do seu cadastro.
          </Text>

          <Text fontSize={0.875} component='li'>
            Não é mais necessário registrar Mudança de território para as equipes e unidades anteriores ao
            reterritorializar um cidadão. Esse registro é exigido apenas quando há necessidade de desvinculá-lo de um
            território, sem nova reterritorialização dentro do mesmo município.
          </Text>

          <Text fontSize={0.875} component='li'>
            Além disso, todos os cidadãos que estavam vinculados a múltiplas equipes ou famílias foram automaticamente
            ajustados para apenas um território e uma família, conforme o último Cadastro Individual atualizado.
          </Text>

          <Text fontSize={0.875} component='li'>
            Com essa melhoria, os relatórios consolidados passam a refletir o mesmo conjunto de cidadãos do
            Acompanhamento de Cidadãos Vinculados.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_M_CHAT_RF_ENABLED && (
        <NewsHeadingSection
          title='Avaliação do M-CHAT-R/F™ completo com Entrevista de Seguimento na puericultura'
          icon={<img src={PuericulturaIcon} alt='Puericultura' css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='avaliacao-M-CHAT-RF-completo-entrevista-seguimento-puericultura-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875}>
              No atendimento de <strong>Puericultura para crianças de 16 a 30 meses,</strong> agora é possível aplicar o{' '}
              <strong>
                M-CHAT-R/F™ (Checklist Modificado para Autismo em Crianças Pequenas) de forma completa diretamente no
                sistema.
              </strong>{' '}
              Trata-se de um instrumento de triagem amplamente utilizado para identificar sinais precoces do Transtorno
              do Espectro Autista (TEA).
            </Text>
            <Text fontSize={0.875}>
              Com essa atualização, os profissionais de saúde podem aplicar, registrar e analisar os resultados do
              M-CHAT-R/F sem sair do sistema. Quando o resultado indicar necessidade de investigação, o profissional
              também pode preencher a <strong>Entrevista de Seguimento</strong> diretamente na plataforma, facilitando o
              encaminhamento para diagnóstico.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_m_chat_rf_puericultura.webm'
              pausedSrc='/static/novidades/5-5_m_chat_rf_puericultura.webp'
              alt='Gif mostrando o acesso até o M-CHAT-R através da puericultura, e o preenchimento do instrumento.'
            />
            <Text fontSize={0.875} component='li'>
              Após o registro de uma <strong>avaliação do M-CHAT-R/F™,</strong> é possível visualizar os resultados
              através do modal de <strong>Acompanhamento da criança,</strong> ou selecionando a opção{' '}
              <strong>Histórico de resultados</strong> na seção do M-CHAT-R/F™.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_m_chat_rf_historico_resultado.webm'
              pausedSrc='/static/novidades/5-5_m_chat_rf_historico_resultado.webp'
              alt='Gif mostrando o histórico de resultados'
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_INTEGRACAO_REGULACAO_ENABLED && (
        <NewsHeadingSection
          title='Regulação assistencial'
          icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
          id='regulacao-assistencial-5-5'
        >
          <VFlow vSpacing={0.5}>
            <NewsListItem fontSize={0.875}>
              Agora no módulo da <strong>Garantia de Acesso</strong>, é apresentada a possibilidade de consultar a aba
              de <strong>Regulação Assistencial</strong>. Nessa seção, os profissionais podem acompanhar as solicitações
              de Exames e Guias de Encaminhamento geradas nos atendimentos que passam pelo processo de regulação
              assistencial. O PEC recebe atualizações de status para essas solicitações através de uma integração com os
              sistemas de regulação próprios configurados pelo administrador da instalação.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              As solicitações podem ser filtradas por{' '}
              <strong>Unidade e Equipe Responsável, Tipo de Solicitação e Status</strong>. Além de ser possível filtrar
              pelo profissional solicitante e o período de realização da solicitação.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_selecao_e_pesquisa_RA.webp'
              pausedSrc='/static/novidades/5-4_selecao_e_pesquisa_RA_paused.webp'
              alt='Gif mostrando a abertura da aba de Garantia de acesso e seleção da regulação assistencial'
            />
            <NewsListItem fontSize={0.875}>
              Todos os profissionais com acesso aos atendimentos que podem solicitar Exames e Guia de Encaminhamento,
              têm acesso à aba da <strong>Regulação Assistencial</strong>, dentro do módulo de{' '}
              <strong>Garantia de Acesso</strong>.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_filtro_RA.webp'
              pausedSrc='/static/novidades/5-4_filtro_RA_paused.webp'
              alt='Gif mostrando a aba da regulação assistencial e a utilização do filtro secundário de "Solicitante"'
            />
            <NewsListItem fontSize={0.875}>
              Ao visualizar um registro de solicitação, é possível ver o seu <strong>histórico de atualizações</strong>{' '}
              para entender como está o processo de regulação assistencial daquele registro no sistema de regulação.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-4_modal_RA.webp'
              pausedSrc='/static/novidades/5-4_modal_RA_paused.webp'
              alt='Gif mostrando a modal de visualização da regulação, com o histórico de atualizações do registro sendo expandido'
            />
            <Text fontSize={0.875}>
              Além disso, o módulo de Regulação assistencial conta com notificações visuais no menu lateral e na
              listagem de solicitações, mantendo os profissionais informados sobre alterações importantes nos
              encaminhamentos, exames e OCIs.
            </Text>
            <NewsListItem fontSize={0.875}>
              Sinalização Visual: Sempre que uma solicitação é atualizada para os status "Devolvido pela regulação",
              "Atendimento agendado" ou "Negada pela regulação", o profissional solicitante é notificado com um contador
              no menu lateral e um ícone de leitura destacado na linha correspondente da listagem.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Filtro de Notificações: Ao ativar o filtro "Ver somente solicitações com notificação", a lista exibe
              apenas os itens que possuem uma notificação pendente. Um contador ao lado do filtro mostra o número total
              de solicitações não lidas.
            </NewsListItem>
            <Text fontSize={0.875}>Atualização de uma solicitação para os status:</Text>
            <NewsListItem fontSize={0.875}>Devolvido pela regulação;</NewsListItem>
            <NewsListItem fontSize={0.875}>Atendimento agendado;</NewsListItem>
            <NewsListItem fontSize={0.875}>Negada pela regulação.</NewsListItem>
            <Text fontSize={0.875}>
              O que encerra a notificação:
              <ul>
                <NewsListItem fontSize={0.875}>No menu lateral:</NewsListItem>
                <ul>
                  <NewsListItem fontSize={0.875}>Ao acessar o módulo com notificações pendentes.</NewsListItem>
                </ul>
                <NewsListItem fontSize={0.875}>Dentro do módulo:</NewsListItem>
                <ul>
                  <NewsListItem fontSize={0.875}>
                    Quando o profissional solicitante clica para visualizar a solicitação.
                  </NewsListItem>
                  <NewsListItem fontSize={0.875}>
                    Quando o status da solicitação é alterado para qualquer outro diferente de "Devolvido pela
                    regulação", "Atendimento agendado" ou "Negada pela regulação".
                  </NewsListItem>
                </ul>
              </ul>
            </Text>
            <Text fontSize={0.875}>Veja como é exibido:</Text>
            <NewsImg
              src='/static/novidades/5-4_notificacao_regulacao_menu_lateral.webp'
              alt='Imagem exibindo as notificações de Regulação assistencial no menu lateral'
            />
            <NewsImg
              src='/static/novidades/5-4_notificacao_regulacao_lista.webp'
              alt='Imagem exibindo as notificações de Regulação assistencial na listagem'
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Renovar prescrição de uso contínuo'
        icon={<Consulta css={styles.iconSVG} />}
        id='renovar-prescricao-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875} component='li'>
            Atualmente, tratamentos com medicamentos de uso contínuo que possuem várias prescrições acabam sendo
            apresentados de forma duplicada no prontuário do cidadão.
          </Text>
          <Text fontSize={0.875} component='li'>
            Para melhorar esse fluxo, foi incluída a ação de "Renovar prescrição", disponível apenas para medicamentos
            de uso contínuo. Diferente da ação de "Replicar prescrição", o fluxo de "Renovar prescrição" agrupa todas as
            prescrições relacionadas em um único tratamento.
          </Text>
          <Text fontSize={0.875} component='li'>
            Ela pode ser utilizada através do histórico de prescrições ou acessando os "Medicamentos em uso" do cidadão.
          </Text>
          <NewsGif
            src='/static/novidades/5-5_renovar-prescricao.webm'
            pausedSrc='/static/novidades/5-5_renovar-prescricao.webp'
            alt='Gif mostrando como renovar uma prescrição de medicamento de uso contínuo.'
          />
          <Text fontSize={0.875} component='li'>
            Ao renovar uma prescrição para um medicamento de uso contínuo, a nova prescrição é agrupada com as
            anteriores do mesmo tratamento. É possível visualizar a evolução de prescrições de um tratamento nos
            "Medicamentos em uso" do cidadão.
          </Text>
          <NewsGif
            src='/static/novidades/5-5_visualizar-renovacao-prescricao.webm'
            pausedSrc='/static/novidades/5-5_visualizar-renovacao-prescricao.webp'
            alt='Gif mostrando prescrição de medicamento de uso contínuo renovada.'
          />
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_GRAFICOS_PRE_TERMO_ENABLED && (
        <NewsHeadingSection
          title='Adaptação dos gráficos de medições para crianças Pré-termo'
          icon={<SdcIcon css={styles.iconSVG} />}
          id='graficos-pre-termo-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              Agora o PEC e-SUS APS identifica crianças nascidas pré-termo e aplica a correção de idade nas
              visualizações de crescimento nos gráficos de medições, utilizando os parâmetros do INTERGROWTH-21.
            </Text>
            <Text fontSize={0.875} component='p'>
              Os gráficos de peso, altura e perímetro cefálico exibem as curvas para prematuros e mostram a idade
              cronológica por semanas.
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_grafico_peso_pre_termo.webp'
                alt='Conteúdo do Gráfico de peso apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de peso Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o peso em kg (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Peso, Idade cronológica e Data.'
              />
              <CarouselItem
                image='/static/novidades/5-5_grafico_altura_pre_termo.webp'
                alt='Conteúdo do Gráfico de altura apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de medida Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o comprimento em cm (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Comprimento, Idade cronológica e Data.'
              />
              <CarouselItem
                image='/static/novidades/5-5_grafico_perimetro_cefalico_pre_termo.webp'
                alt='Conteúdo do Gráfico de perímetro cefálico apresentado por semanas para bebês na faixa etária pré-termo, indicando faixa de medida Adequado (verde) e Risco (vermelho) acima e abaixo da linha de referência do gráfico. O gráfico mostra o perímetro cefálico em cm (no eixo vertical) e as semanas (no eixo horizontal), com uma linha azul de tendência de crescimento e a exibição dos dados de Perímetro cefálico, Idade cronológica e Data.'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_GRUPOS_ATIVIDADE_COLETIVA_ENABLED && (
        <NewsHeadingSection
          title='Criação e gestão de grupos de atividade coletiva'
          icon={<AtividadeColetivaIcon css={css(styles.iconSVG, styles.fillableIconSVG)} />}
          id='gestao-grupo-atividade-coletiva-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              O módulo de Atividade coletiva passa a contar com a funcionalidade de Gestão de Grupos. Por meio desse
              novo item no menu lateral, é possível criar e gerenciar listas de participantes, incluindo cidadãos e
              profissionais, para organizar os grupos de atividades coletivas da unidade de saúde.
            </Text>
            <Text fontSize={0.875} component='p'>
              Os grupos podem ser de dois tipos:
            </Text>
            <Text component='ul' style={styles.noMarginUl}>
              <NewsListItem fontSize={0.875}>
                <strong>Atividade em saúde:</strong> permite incluir cidadãos participantes e profissionais envolvidos;
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>Reunião:</strong> composto apenas por profissionais.
              </NewsListItem>
            </Text>
            <Text fontSize={0.875} component='p'>
              Após a criação os grupos podem ser:
            </Text>
            <Text component='ul' style={styles.noMarginUl}>
              <NewsListItem fontSize={0.875}>
                <strong>atualizados</strong>, com inclusão ou remoção de participantes;
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>inativados</strong>, quando pausados temporariamente;
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>excluídos</strong>, quando descontinuados.
              </NewsListItem>
            </Text>
            <Text fontSize={0.875} component='p'>
              Todos os grupos criados ficam disponíveis em uma tabela com as seguintes opções de filtro para facilitar a
              gestão:
            </Text>
            <Text component='ul' style={styles.noMarginUl}>
              <NewsListItem fontSize={0.875}>Unidade de saúde;</NewsListItem>
              <NewsListItem fontSize={0.875}>Equipes envolvidas;</NewsListItem>
              <NewsListItem fontSize={0.875}>Tipo de grupo;</NewsListItem>
              <NewsListItem fontSize={0.875}>Visualizar apenas grupos inativos;</NewsListItem>
              <NewsListItem fontSize={0.875}>Visualizar apenas grupos dos quais você participa;</NewsListItem>
              <NewsListItem fontSize={0.875}>Campo de busca por nome do grupo.</NewsListItem>
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_1.webp'
                alt='Imagem exibindo acesso ao módulo de Gestão de grupos de atividade coletiva'
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_2.webp'
                alt='Imagem exibindo listagem do módulo de Gestão de grupos de atividade coletiva'
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_3.webp'
                alt='Imagem exibindo filtros do módulo de Gestão de grupos de atividade coletiva'
              />
              <CarouselItem
                image='/static/novidades/5-5_gestao_grupos_atividade_coletiva_4.webp'
                alt='Imagem exibindo cadastro do módulo de Gestão de grupos de atividade coletiva'
              />
            </Carousel>
            <Text fontSize={0.875}>
              Além disso, é possível utilizar um grupo previamente cadastrado durante o registro de uma atividade
              coletiva. Ao selecionar o grupo em registros de Atividade em saúde ou em Reunião, os participantes
              (cidadãos e profissionais) são automaticamente carregados nas tabelas do registro.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_cadastro_gestao_grupos_atividade_coletiva.webp'
              pausedSrc='/static/novidades/5-5_cadastro_gestao_grupos_atividade_coletiva-paused.webp'
              alt='Gif mostrando cadastro de grupos de atividade coletiva'
            />
            <Text fontSize={0.875}>
              Com essa funcionalidade, torna-se mais simples gerenciar grupos fixos e recorrentes da unidade, além de
              agilizar o registro das atividades coletivas, evitando a necessidade de adicionar manualmente os mesmos
              participantes a cada novo registro.
            </Text>
          </VFlow>
        </NewsHeadingSection>
      )}
      {MOTIVO_PRESCRICAO_ENABLED && (
        <NewsHeadingSection
          title='Inclusão do campo Motivo da prescrição'
          id='motivo-prescricao-5-5'
          icon={<Consulta />}
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='li'>
              Foi incluído um novo campo obrigatório na prescrição de medicamentos, o "Motivo da prescrição". Nele, é
              preciso informar um CID-10 ou um CIAP-2 associado ao medicamento sendo prescrito.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_motivo_prescricao.webm'
              pausedSrc='/static/novidades/5-5_motivo_prescricao_paused.webp'
              alt='Gif mostrando o novo campo Motivo da prescrição'
            />
            <Text fontSize={0.875} component='li'>
              É possível visualizar o motivo da prescrição de um medicamento também na Folha de rosto, no Histórico e na
              impressão de atendimento.
            </Text>
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_VINCULACAO_CUIDADO_ENABLED && (
        <NewsHeadingSection
          title='Melhorias em Encaminhamento e Cuidado compartilhado'
          id='melhorias-encaminhamento-e-cc-5-5'
          icon={<GarantiaAcessoIcon css={styles.iconSVG} />}
        >
          <Text fontSize={0.875}>
            Os módulos de Cuidado compartilhado e Encaminhamento foram aprimorados para os atendimentos individuais.
            Agora, estão unificados na nova aba Encaminhamento/Compartilhamento de cuidado. Confira as principais
            novidades:
          </Text>
          <ul>
            <VFlow vSpacing={0.5}>
              <NewsListItem fontSize={0.875}>
                A nova aba Encaminhamento/Compartilhamento de cuidado concentra tanto a geração de guias de
                encaminhamento quanto o compartilhamento de cuidados, substituindo a antiga aba Encaminhamentos. A
                partir de agora, todas as guias são geradas por essa nova aba, utilizando CBO, Especialidade e
                Classificação de prioridade. O histórico anterior permanece acessível para consulta de encaminhamentos
                antigos, por meio do Histórico anterior à unificação.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_nova_aba_guia_encaminhamento_especialidade.webp'
                alt='Imagem exibindo a guia de encaminhamento'
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <NewsListItem fontSize={0.875}>
                A impressão das guias de encaminhamento foi atualizada para incluir informações importantes, como
                endereço, CPF e CNS do cidadão. Além disso, a quantidade de caracteres permitida no campo de texto foi
                ampliada para até 2000 caracteres.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_impressao_guia_encaminhamento_especialidade.webp'
                alt='Imagem exibindo impressão da guia de encaminhamento'
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <NewsListItem fontSize={0.875}>
                Agora é possível compartilhar cuidados entre estabelecimentos da Atenção Primária e serviços
                especializados de referência, facilitando a integração do cuidado entre os diferentes níveis de atenção.
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-4_compartilhamento_cuidado_entre_estabelecimentos.webp'
                alt='Imagem exibindo o compartilhamento de cuidado entre estabelecimentos da Atenção Primária e serviços especializados'
                style={{ marginTop: 8, marginBottom: 16 }}
              />
              <VFlow vSpacing={0.5}>
                <NewsListItem fontSize={0.875}>
                  O sistema também permite aos profissionais eMulti compartilhar cuidados com:
                </NewsListItem>
                <ul>
                  <NewsListItem fontSize={0.875}>Profissionais eMulti de sua equipe;</NewsListItem>
                  <NewsListItem fontSize={0.875}>Profissionais das equipes vinculadas.</NewsListItem>
                </ul>
              </VFlow>
              <NewsListItem fontSize={0.875}>
                O módulo de Cuidado compartilhado também passa a considerar, na criação dos registros, os períodos de
                ausência dos profissionais (como férias, licenças, atestados ou cursos) registrados na "Configuração de
                fechamentos da agenda".
              </NewsListItem>
              <NewsImg
                src='/static/novidades/5-5_compartilhamento_cuidado_fechamento_agenda.webp'
                alt='Imagem exibindo um profissional com agenda fechada no compartilhamento de cuidado'
                style={{ marginTop: 8, marginBottom: 8 }}
              />
              <Text fontSize={0.875}>
                Essa melhoria tem como objetivo evitar que um cuidado seja compartilhado para um profissional que não
                está disponível no momento.
              </Text>
            </VFlow>
          </ul>
        </NewsHeadingSection>
      )}
      {PILOTO_EXAMES_SAUDE_MULHER_ENABLED && (
        <NewsHeadingSection
          title='PDFs para solicitar exames de mamografia e citopatológico de colo uterino'
          icon={<Icon icon='fileWithItemsOutline' css={css(styles.iconSVG, styles.fillableBlueIconSVG)} />}
          id='pdfs-solicitar-exames-saude-mulher-5-5'
        >
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='li'>
              Com objetivo de promover, fortalecer e acompanhar ações relacionadas à saúde da mulher, o PEC conta com
              novos PDFs de <strong>solicitações de exames para mamografia e citopatológico de colo uterino</strong> que
              seguem o padrão do <strong>Sistema de Informação do Câncer - SISCAN</strong>. Desta forma, as informações
              podem ser integradas ao SISCAN de forma mais fácil e ágil, facilitando a rotina do profissional de saúde.
            </Text>
            <Text fontSize={0.875} component='li'>
              Os PDFs estão disponíveis para impressão e preenchimento de acordo com os exames registrados no
              {' SOAP > Plano > Solicitação de exames/procedimentos.'}
            </Text>
            <NewsImg
              src='/static/novidades/5-5_plano_req_citopatologico.webp'
              alt='Imagem exibindo a opção de impressão da requisição de citopatológico de colo uterino'
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection
        title='Possibilidade de escolha da idade gestacional'
        icon={<Icon icon='pregnant' css={[styles.iconSVG, styles.fillableIconSVG]} />}
        id='possibilidade-escolha-idade-gestacional-5-5'
      >
        <VFlow vSpacing={0.5}>
          <Text fontSize={0.875} component='li'>
            Foi incluída a possibilidade de definir qual idade gestacional é utilizada para fins de acompanhamento
            durante a gestação no sistema. É possível escolher entre a DUM e a ecografia. Quando escolhida a ecografia,
            é considerado o primeiro exame realizado após a DUM.
          </Text>
          <NewsGif
            src='/static/novidades/5-5_possibilidade_escolha_ig.webp'
            pausedSrc='/static/novidades/5-5_possibilidade_escolha_ig_paused.webp'
            alt='Gif mostrando a possibilidade de escolha da idade gestacional'
          />
          <Text fontSize={0.875} component='li'>
            Nos gráficos de medições, acompanhamento de pré-natal e acompanhamento de condições de saúde, o início da
            gestação para fins de cálculo passa a ser definido com base na escolha do profissional.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_PRONTUARIO_FAMILIAR_ENABLED && (
        <NewsHeadingSection title='Prontuário Familiar' id='prontuario-familiar-5-5' icon={<CidadaoIcon />}>
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='li'>
              A nova aba <b>Prontuário Familiar</b> no cadastro do cidadão reúne, em um só lugar, informações
              importantes sobre a família de um cidadão. Com ela, fica mais simples ter uma visão completa sobre cada
              cidadão e sua família.
            </Text>
            <Text fontSize={0.875} component='li'>
              Diretamente no cadastro do cidadão e em um só lugar, são apresentadas informações como dados cadastrais da
              família, identificação dos familiares e acesso aos seus cadastros ou prontuários (conforme as permissões
              do usuário), além de detalhes sobre as condições de moradia.
            </Text>
            <Text fontSize={0.875} component='li'>
              Também estão disponíveis indicadores importantes, como o Risco de Insegurança Alimentar e indicação de
              recebimento do Bolsa Família, quando é o caso, bem como o histórico das últimas visitas realizadas à
              família.
            </Text>
            <Text fontSize={0.875} component='li'>
              Todo esse conteúdo pode ser consultado tanto durante o atendimento quanto ao acessar apenas o cadastro.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_prontuario_familiar.webm'
              pausedSrc='/static/novidades/5-5_prontuario_familiar_paused.webp'
              alt='Gif mostrando o novo Prontuário Familiar'
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_RELATORIO_GERENCIAL_CADASTRO_INDIVIDUAL_ENABLED && (
        <NewsHeadingSection
          title='Relatório gerencial de cadastro individual'
          id='relatorio-gerencial-cadastro-individual-5-5'
          icon={<Relatorios />}
        >
          <VFlow vSpacing={0.5}>
            <NewsListItem fontSize={0.875}>
              Novo <strong>Relatório Gerencial de Cadastro Individual</strong>. Estamos disponibilizando um novo
              relatório gerencial que permite uma análise detalhada dos cadastros individuais. Este recurso foi
              desenvolvido para oferecer maior visibilidade e facilitar o acompanhamento de informações relacionadas ao
              cadastro individual.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Diferente dos demais relatórios gerenciais, o <strong>Relatório Gerencial de Cadastro Individual</strong>{' '}
              exibe sempre o <strong>último registro atualizado</strong> vinculado à equipe de acompanhamento. Por se
              tratar de um panorama em tempo real da situação do cidadão, este relatório não utiliza filtros de período,
              garantindo que você visualize o dado mais recente disponível.
            </NewsListItem>
            <NewsGif
              src='/static/novidades/5-5_uso_relatorio_cadastro.webm'
              pausedSrc='/static/novidades/5-5_uso_relatorio_cadastro_paused.webp'
              alt='Gif mostrando o uso do relatório e geração da tabela'
            />
            <NewsListItem fontSize={0.875}>
              O relatório introduz o campo <strong>"Agrupar por"</strong>, que altera a visualização de dados com
              múltipla seleção:
            </NewsListItem>
            <ul>
              <NewsListItem fontSize={0.875}>
                <strong>Pessoas:</strong> Agrupa as informações para garantir que cada cidadão seja contabilizado apenas
                uma vez.
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                <strong>Registros:</strong> Lista cada opção selecionada de forma independente. Nesta visão, o
                totalizador é ocultado para evitar duplicidade na contagem real de cidadãos.
              </NewsListItem>
            </ul>
            <NewsGif
              src='/static/novidades/5-5_agrupar_por_relatorio.webm'
              pausedSrc='/static/novidades/5-5_agrupar_por_relatorio_paused.webp'
              alt='Gif mostrando a funcionalidade Agrupar Por'
            />
            <NewsListItem fontSize={0.875}>
              <strong>Exportação de dados:</strong> Permite a exportação dos resultados em arquivos CSV, garantindo
              maior flexibilidade no uso e compartilhamento das informações.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_print_csv_gerado.webp'
              alt='Print do CSV gerado'
              style={{ marginTop: 8 }}
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      <NewsHeadingSection title='Painel de chamadas' icon={<Icon icon='desktopOutline' />} id='painel-chamadas-5-5'>
        <VFlow vSpacing={0.5}>
          <ul>
            <NewsListItem fontSize={0.875}>
              Agora o profissional pode <strong>chamar o paciente para atendimento</strong> em uma unidade de saúde por
              meio de um <strong>Painel de chamadas</strong>.
            </NewsListItem>
          </ul>
          <NewsGif
            src='/static/novidades/5-5_painel_chamadas_visao_geral.webm'
            pausedSrc='/static/novidades/5-5_painel_chamadas_visao_geral.webp'
            alt='Tela do painel de chamadas exibindo a sala e o paciente chamado'
          />
          <ul>
            <NewsListItem fontSize={0.875}>
              Ele pode ser utilizado através da opção <strong>"Chamar"</strong> da{' '}
              <strong>Lista de atendimentos</strong>.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Ao chamar um paciente, é necessário confirmar o tipo de atendimento e a sala/consultório para onde ele
              será chamado.
            </NewsListItem>
          </ul>
          <NewsGif
            src='/static/novidades/5-5_painel_chamadas_lista_atendimentos.webm'
            pausedSrc='/static/novidades/5-5_painel_chamadas_lista_atendimentos.webp'
            alt='Lista de atendimentos com o botão chamar destacado'
          />
          <ul>
            <NewsListItem fontSize={0.875}>
              Para habilitar a funcionalidade, é necessário que o <strong>coordenador</strong> do estabelecimento de
              saúde <strong>configure ao menos um dispositivo</strong> para utilizar o painel e{' '}
              <strong>cadastre as salas disponíveis</strong> na sua unidade.
            </NewsListItem>
          </ul>
        </VFlow>
      </NewsHeadingSection>
      {PILOTO_RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED && (
        <NewsHeadingSection title='Retificação do atendimento de procedimentos' id='retificacao-procedimentos-5-5'>
          <VFlow vSpacing={0.5}>
            <Text fontSize={0.875} component='p'>
              Foi adicionada a funcionalidade de retificar atendimentos de procedimentos.
            </Text>
            <Text fontSize={0.875} component='p'>
              Através do histórico do cidadão, é possível que a lotação profissional que realizou o atendimento de
              procedimentos retifique o registro por meio de duas funcionalidades: "Editar registro" e "Remover registro
              do prontuário".
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_botao_historico.webp'
                alt='Botão de retificação no histórico de atendimentos'
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_modal.webp'
                alt='Modal de retificação de atendimentos'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Ao escolher a opção "Editar registro" é possível adicionar, editar e remover registros do atendimento de
              procedimentos.
            </Text>
            <NewsGif
              src='/static/novidades/5-5_retificacao_procedimentos_edicao.webm'
              pausedSrc='/static/novidades/5-5_retificacao_procedimentos_edicao_capa.webp'
              alt='Animação mostrando a edição de um atendimento de procedimentos'
            />
            <Text fontSize={0.875} component='p'>
              As informações dos registros que foram editados ou removidos são enviadas para a base nacional. Além
              disso, os registros editados ou removidos podem ser visualizados na Trilha de Auditoria do PEC e-SUS APS.
              A auditoria dos registros editados e removidos é exibida para o usuário no seguinte formato:
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_auditoria_exclusao.webp'
                alt='Registro de auditoria de exclusão de atendimento'
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_auditoria_edicao.webp'
                alt='Registro de auditoria de edição de atendimento'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Após a edição ou remoção, o histórico do cidadão e as impressões dos atendimentos são adaptados para
              informar quais registros foram retificados:
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_botao_impressao.webp'
                alt='Botão de impressão de registros inativos'
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_impressao.webp'
                alt='Impressão de um registro inativo'
              />
            </Carousel>
            <Text fontSize={0.875} component='p'>
              Para visualizar os registros removidos, é necessário ativar o filtro "Exibir registros removidos" no botão
              "Outros filtros":
            </Text>
            <Carousel>
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_filtro_removidos.webp'
                alt='Filtro para exibir atendimentos inativos'
              />
              <CarouselItem
                image='/static/novidades/5-5_retificacao_procedimentos_historico_removido.webp'
                alt='Registro removido no histórico de atendimentos'
              />
            </Carousel>
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_RNDS_REPM_ENABLED && PILOTO_ASSINADOR_REPM_ENABLED && (
        <NewsHeadingSection
          title='Assinatura digital REPM'
          icon={<SignatureIcon css={styles.iconSVG} />}
          id='assinatura-digital-repm-5-5'
        >
          <VFlow vSpacing={0.5}>
            <NewsListItem fontSize={0.875}>
              A Rede Nacional de Dados em Saúde (RNDS) está em constante evolução e a novidade desta versão é a
              possibilidade de assinar digitalmente o documento de{' '}
              <strong>Registro Eletrônico da Prescrição de Medicamento (REPM)</strong>, através do PEC ao prescrever um
              medicamento referenciado pela OBM.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Ao assinar digitalmente um REPM, ele se torna um registro confiável: assegura-se que o profissional
              prescritor e os dados inseridos são válidos, verdadeiros e verificados. Quando isso acontece, o registro
              fica apto a ser utilizado por outros sistemas informacionais de forma segura.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Para assinar um REPM, é necessário que a instalação esteja com a RNDS configurada corretamente, o
              profissional tenha o número do conselho de classe cadastrado e possua algum serviço de assinatura digital
              vinculado ao seu CPF.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_modal-assinatura-digital-repm.webp'
              alt='Imagem exibindo a modal de assinatura dos documentos REPM'
              style={{ marginTop: 8 }}
            />
            <NewsImg
              src='/static/novidades/5-5_tela-provedores-assinatura-digital.webp'
              alt='Imagem exibindo a modal de assinatura dos documentos REPM'
              style={{ marginTop: 8 }}
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      {PILOTO_INATIVACAO_IMOVEIS_ENABLED && (
        <NewsHeadingSection
          title='Inativação de imóveis'
          icon={<Icon icon='houseFilled' />}
          id='inativacao-imoveis-5-5'
        >
          <VFlow vSpacing={0.5}>
            <NewsListItem fontSize={0.875}>
              O Acompanhamento do território agora permite a inativação de cadastros de imóveis duplicados, que não
              existem mais ou mesmo que foram cadastrados equivocadamente. Com essa nova funcionalidade será possível
              separá-los dos imóveis que devem ser realmente acompanhados.
            </NewsListItem>
            <NewsListItem fontSize={0.875}>
              Diretamente no cadastro do imóvel, você poderá marcar um imóvel como "Inativo". Imóveis inativados deixam
              de ser exibidos na microárea e na aba "Fora de área", passando para a nova aba "Inativos". Enquanto
              inativos, eles também não serão exibidos no aplicativo e‑SUS Território, Reterritorialização, CDS nem
              contabilizados em relatórios. Para desfazer uma inativação, quando necessário, basta atualizar o cadastro
              e desmarcar a opção.
            </NewsListItem>
            <NewsImg
              src='/static/novidades/5-5_inativacao-imoveis.gif'
              alt='Gif mostrando a nova funcionalidade de inativação de imóveis no acompanhamento do território'
            />
          </VFlow>
        </NewsHeadingSection>
      )}
      {SOLICITACAO_EXAME_CITOPATOLOGICO_UTERINO_ENABLED && (
        <NewsHeadingSection
          title='Nova solicitação para exame de citopatológico de colo uterino'
          icon={<Icon icon='female' />}
          id='solicitacao-exame-citopatologico-colo-uterino-5-5'
        >
          <Flow direction='vertical' gap={0.5}>
            <Text fontSize={0.875}>
              Com objetivo de promover a integração de sistemas de saúde e acompanhar ações relacionadas à saúde da
              mulher, foi incluído no PEC uma nova{' '}
              <strong>solicitação de exames para citopatológico de colo uterino</strong> que segue o padrão do{' '}
              <strong>Sistema de Informação do Câncer - SISCAN</strong>. Desta forma, as informações estarão
              padronizadas e futuramente poderão ser integradas de forma automática, facilitando a rotina do
              profissional de saúde.
            </Text>
            <Text fontSize={0.875}>
              A nova solicitação do exame de citopatológico de colo uterino está disponível através do SOAP {'>'} Plano{' '}
              {'>'} Solicitação de exames/procedimentos {'>'} menu do card da solicitação inserida para os seguintes
              exames:
            </Text>
            <ul>
              <NewsListItem fontSize={0.875}>
                201020033 - COLETA DE MATERIAL DO COLO DE ÚTERO PARA EXAME CITOPATOLÓGICO
              </NewsListItem>
              <NewsListItem fontSize={0.875}>203010019 - EXAME CITOPATOLÓGICO CERVICO-VAGINAL/MICROFLORA</NewsListItem>
              <NewsListItem fontSize={0.875}>
                203010086 - EXAME CITOPATOLÓGICO CERVICO VAGINAL/MICROFLORA-RASTREAMENTO
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                201020076 - COLETA DE MATERIAL DO COLO DO ÚTERO PARA EXAME MOLECULAR DE DETECÇÂO DE HPV
              </NewsListItem>
              <NewsListItem fontSize={0.875}>
                201020084 - ENTREGA DE MATERIAL OBTIDO POR AUTO COLETA PARA EXAME MOLECULAR PARA DETECÇÃO DE HPV, NO
                COLO DO ÚTERO
              </NewsListItem>
              <NewsListItem fontSize={0.875}>202100251 - EXAME MOLECULAR DE DETECÇÂO DE HPV</NewsListItem>
            </ul>
            <NewsImg
              src='/static/novidades/5-5_citopatologico_colo_uterino.gif'
              alt='Gif mostrando a solicitação para exame citopatológico do colo uterino'
            />
          </Flow>
        </NewsHeadingSection>
      )}
    </Fragment>
  )
}

const styles = {
  iconSVG: css`
    margin-right: 0.25rem;
    width: 2rem;
    height: 2rem;
  `,
  fillableIconSVG: css`
    fill: ${gray.c60};
  `,
  fillableBlueIconSVG: css`
    fill: ${blue.c40};
  `,
  noMarginUl: css`
    margin: 0;
  `,
}
